import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/momentum')({
  beforeLoad: () => {
    throw redirect({ to: '/today', search: { tab: 'friends' }, replace: true })
  },
})
